import { IProductType } from "@cakeiteasy/web-utils";

export const getRequestUrl = (productType: IProductType): string => {
  const {
    requestUrl,
    requestForm,
    customRequestFormLink,
    useCustomRequestFormLink,
  } = productType;

  if (useCustomRequestFormLink && customRequestFormLink) {
    return customRequestFormLink;
  }

  if (!useCustomRequestFormLink && requestForm && requestUrl) {
    if (requestUrl.endsWith('/')) {
      return `${requestUrl}${requestForm}`;
    }

    return `${requestUrl}/${requestForm}`;
  }

  return '';
};
